import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpClient
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppConfigProvider } from '../app-config.provider';
import { catchError } from 'rxjs/operators';
import { UiNotificationService } from '../services';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private readonly appConfigProvider: AppConfigProvider,
    private readonly uiNotificationService: UiNotificationService,
    private readonly translateService: TranslateService,
    private readonly httpClient: HttpClient
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url.indexOf('api/o') === -1 && request.url.indexOf('api') > 0) {
      const bearerToken = this.appConfigProvider.getBearerToken();
      if (bearerToken) {
        request = this.addToken(request, bearerToken);
      }
      if (request.url.indexOf('draftMode') > 0) {
        request = this.addUnpublished(request);
      }
      if (request.method.toLocaleLowerCase() !== "get" && request.url.indexOf('clearCache') > 0) {
        this.httpClient.post("/api/o/cache/clear?clearCache=true",{}).subscribe();
      }
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let msg = null;
        let status = null;

        if (error && error.error) {
          msg = error.error.message + ' ' + error.error.details;
          status = error.error.statusCode;
        }
        //
        if (msg) {
          if ((msg as string).indexOf('A schema with this name already exists') > -1) {

            this.translateService.get('T').subscribe(c => {
              this.uiNotificationService.error(c.SCHEMA_NAME_TAKEN, c.ERROR);
            });

            //this.uiNotificationService.errorAsync(this.translateService.get('T.SCHEMA_NAME_TAKEN'));
          } else if ((msg as string).indexOf('Another content with the same value exists') > -1) {
            //this.uiNotificationService.errorAsync(this.translateService.get('T.CONTENT_NAME_EXISTS'));
            this.translateService.get('T').subscribe(c => {
              this.uiNotificationService.error(c.CONTENT_NAME_EXISTS, c.ERROR);
            });
          } else if ((msg as string).indexOf('ttt') > -1) {
            //this.uiNotificationService.errorAsync(this.translateService.get('T.CONTENT_NAME_EXISTS'));
            this.translateService.get('T').subscribe(c => {
              this.uiNotificationService.error(c.ERROR_MESSAGE, c.ERROR);
            });
          } else {
            //this.uiNotificationService.error(msg, status);
            console.log(msg);
            console.log(request);
          }
        } else {
          // *to be translated
          this.uiNotificationService.error('Error!!!', 'Error');
        }
        return throwError(error);
      }));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    const r = request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
    return r;
  }

  private addUnpublished(request: HttpRequest<any>) {
    const r = request.clone({
      setHeaders: {
        'X-Unpublished': ''
      }
    });
    return r;
  }
}
